import Swiper from 'swiper';

export default {
  init() {
    new Swiper ('.people_slider__container', {
      // Optional parameters
      direction: 'horizontal',
      effect: 'slide',
      slidesPerView: 1,
      speed: 600,
      spaceBetween: 40,
      pagination: {
        el: '.quality_slider__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '#people-next',
        prevEl: '#people-prev',
      },
    })
  }
}
